export default class ReleaseApproval {
  constructor(client) {
    this.client = client;
    this.resourceUrl = "/poeReleaseApproval";
  }

  getAllReleaseApprovals() {
    return this.client.get(`${this.resourceUrl}`);
  }

  createReleaseApproval(postData) {
    return this.client.post(`${this.resourceUrl}`, postData);
  }

  updateReleaseApproval(releaseApprovalKey, postData) {
    return this.client.post(
      `${this.resourceUrl}/${releaseApprovalKey}`,
      postData
    );
  }

  updateTargetDate(releaseApprovalKey, postData) {
    return this.client.patch(
      `${this.resourceUrl}/${releaseApprovalKey}`,
      postData
    );
  }
}
